exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".textArea-66064{padding:8px 12px}", ""]);

// Exports
exports.locals = {
	"textArea": "textArea-66064"
};